import { approvalsNotificationListMaxLimit, isApprovalByTeamEnabled } from '@gonfalon/dogfood-flags/dogfood-flags';
import { Record } from '@gonfalon/immutable-shim/immutableShim';
import {
  isChecked,
  isFalse,
  isLength,
  isNotEmpty,
  isNotZero,
  isValidNotifyMembersList,
  validateRecord,
} from '@gonfalon/legacy-form-validation/validationUtils';

import { isValidResourceConfirmation } from '#utils/confirmationUtils';

import { isValidNotifyReviewersCount } from '../isValidNotifyReviewersCount';
import { type PendingChangesFormRecordProps } from '../types';

const MINIMUM_DESCRIPTION_CHAR = 1;
const MAXIMUM_DESCRIPTION_CHAR = 5000;

export class PendingChangesFormRecord extends Record<PendingChangesFormRecordProps>({
  isInitialized: false,
  isScheduleSelected: false,
  isApprovalSelected: false,
  isInviteMemberSelected: false,
  isApplyWithoutApprovalSelected: false,
  usesLaunchDarklyApprovalService: false,
  isCommentRequired: false,
  isConfirmationRequired: false,
  resourceKey: '',
  resourceName: '',
  isAcknowledgeConflictsRequired: false,
  isLoadingConflicts: false,
  hasConflictsError: false,
  executionDate: 0,
  description: '',
  notifyMembers: [],
  notifyTeams: [],
  reviewers: [],
  acknowledgeConflicts: false,
  resourceConfirmation: '',
  comment: '',
  integrationConfig: {},
}) {
  validate() {
    const predicates = [];
    if (this.isScheduleSelected) {
      predicates.push(isNotZero('executionDate'));
    }
    if (this.isApprovalSelected) {
      predicates.push(isNotEmpty('description'));
      predicates.push(isLength(MINIMUM_DESCRIPTION_CHAR, MAXIMUM_DESCRIPTION_CHAR)('description'));
      if (this.usesLaunchDarklyApprovalService) {
        if (isApprovalByTeamEnabled()) {
          predicates.push(isNotEmpty('reviewers'));
          predicates.push(
            isValidNotifyReviewersCount(
              approvalsNotificationListMaxLimit(),
              this.notifyTeams,
              this.notifyMembers,
            )('reviewers'),
          );
        } else {
          predicates.push(isNotEmpty('notifyMembers'));
          predicates.push(isValidNotifyMembersList(approvalsNotificationListMaxLimit())('notifyMembers'));
        }
      }
    } else {
      if (this.isAcknowledgeConflictsRequired) {
        predicates.push(isChecked('acknowledgeConflicts'));
      }
      if (this.isCommentRequired) {
        predicates.push(isNotEmpty('comment'));
      }
      if (this.isConfirmationRequired) {
        predicates.push(isNotEmpty('resourceConfirmation'));
        predicates.push(isValidResourceConfirmation(this.resourceKey, this.resourceName)('resourceConfirmation'));
      }
    }
    predicates.push(isFalse('isLoadingConflicts'));

    return validateRecord(this, ...predicates);
  }
}
